import * as React from "react";
export const AvatarContext = /*#__PURE__*/React.createContext({});
//# sourceMappingURL=AvatarContext.js.map